module.exports = __webpack_public_path__ + "img/loading.ca9104c4.svg";